import React from 'react';

function ManifestiSection() {
  return (
    <article className="ManifestiSection">
      <em>Kapina alustakapitalismia vastaan</em>
      <br />
      <section>
        <h3>1. Me emme ole dataa.</h3>
        <p>Me olemme ihmisiä. Emme klikkauksia, emme sitoutumisprosentteja, emme kohderyhmiä.</p>
        <p>Muut alustat rakentavat taloutensa käyttäjän muuttamisella tuotteeksi.</p>
        <p>
          <strong>Me kieltäydymme olemasta tuote.</strong>
        </p>
      </section>

      <section>
        <h3>2. Yhteisö ei ole algoritmi.</h3>
        <p>Algoritmi optimoi huomiota. Yhteisö rakentaa luottamusta.</p>
        <p>Me emme optimoi ruutuaikaa. Me emme manipuloi näkyvyyttä. Me emme rakenna riippuvuutta.</p>
        <p>
          <strong>Me rakennamme kohtaamisia.</strong>
        </p>
      </section>

      <section>
        <h3>3. Jokainen jäsen on oikea ihminen.</h3>
        <p>Anonymiteetti on internetin voima. Vastuuttomuus on sen varjo.</p>
        <p>Meidän verkossamme jokainen jäsen on vahvasti tunnistettu.</p>
        <p>Ei valeprofiileja. Ei massamanipulaatiota.</p>
        <p>
          <strong>Luottamus alkaa todellisuudesta.</strong>
        </p>
      </section>

      <section>
        <h3>4. Keskustelu ei ole pysyvä varjo.</h3>
        <p>Internet ei unohda. Meidän tilamme unohtaa.</p>
        <p>Keskusteluhistoria tyhjenee. Ei arkistoja, joita kaivaa esiin vuosien päästä.</p>
        <p>Vapaus puhua vaatii oikeuden kadota.</p>
      </section>

      <section>
        <h3>5. Meillä ei ole exit-strategiaa.</h3>
        <p>Suurin osa digitaalisista alustoista rakennetaan myytäväksi.</p>
        <p>Meidän verkkomme ei ole kauppatavara. Sitä ei rakenneta sijoittajille.</p>
        <p>
          <strong>Se rakennetaan jäsenille. Ja se pysyy jäsenillä.</strong>
        </p>
      </section>

      <section>
        <h3>6. Jäsenmaksu on periaate, ei este.</h3>
        <p>
          <em>Jos et maksa tuotteesta, olet tuote.</em>
        </p>
        <p>Me maksamme jäsenyydestä, jotta emme myy dataa, huomiota tai toisiamme.</p>
        <p>
          <strong>Jäsenmaksu on itsenäisyyden hinta.</strong>
        </p>
      </section>

      <section>
        <h3>7. Yleisöä ei ole. On vain osallistujia.</h3>
        <p>Seuraajat ovat passiivisia. Jäsenet ovat aktiivisia.</p>
        <p>Tämä ei ole esiintymislava algoritmille.</p>
        <p>
          <strong>Tämä on huone, jossa ihmiset kohtaavat.</strong>
        </p>
      </section>

      <section>
        <h3>8. Kasvu ei ole itseisarvo.</h3>
        <p>Nykyajan some-alustat tavoittelevat maksimaalista kasvua.</p>
        <p>Meidän verkkomme voi olla pieni. Se voi olla hidas. Se voi olla rajallinen.</p>
        <p>
          <strong>Mutta se kasvaa käyttäjien ehdoilla.</strong>
        </p>
      </section>

      <section>
        <h3>9. Me palautamme internetin kansalaisyhteiskunnalle.</h3>
        <p>Internet syntyi avoimuudesta. Se kaapattiin valvontatalouteen.</p>
        <p>
          Me rakennamme digitaalisen yhdistystilan: paikan, jossa voi keskustella, esitellä, kysyä, kuunnella ja olla.
        </p>
        <p>
          <em>Ilman, että jokainen ele muuttuu dataksi.</em>
        </p>
      </section>

      <section>
        <h3>10. Loppu on väistämätön.</h3>
        <p>Aristoteles kirjoitti, että “lopun tulee olla yhtä yllättävä kuin se on väistämätön.”</p>
        <p>
          Järjestelmä, joka perustuu ihmisten hyväksikäyttöön, on rakenteellisesti <em>epävakaa.</em>
        </p>
        <p>Ihmiset väsyvät. Luottamus murenee. Arvo siirtyy.</p>
        <p>
          Pulina on <strong>Yllättävän väistämätön.</strong>
        </p>
      </section>
    </article>
  );
}

export default ManifestiSection;
